import React from "react"

import containerClasses from "../../styles/container.module.css"
import buttons from "../../styles/buttons.module.css"

const PairImage = ({ src, alt, label }) => (
  <div className="relative">
    <img
      loading="lazy"
      className="w-full block"
      style={{ aspectRatio: "1/1", objectFit: "cover" }}
      src={src}
      alt={alt}
    />
    <div
      className="absolute bottom-0 left-0 right-0 z-10 flex items-center px-3 py-2"
      style={{ backgroundColor: "#0a0a1e" }}
    >
      <p className="mb-0 text-white font-mono text-xs md:text-sm uppercase tracking-wider">
        {label}
      </p>
    </div>
  </div>
)

export const ScarringSection = ({
  overline,
  heading,
  paragraphs,
  faqLinkText,
  faqAnchor,
  pairs,
}) => (
  <div id="scarring" className="bg-white">
    <div className={`${containerClasses.container} py-16 md:py-20 lg:py-24`}>
      {/* Text column */}
      <div className="flex flex-col col-span-4 md:col-span-8 lg:col-span-5 lg:justify-center">
        <p className="mt-0 mb-2 overline">{overline}</p>
        <h2
          className="mt-0 mb-6 fluid-heading-05 leading-tight"
          dangerouslySetInnerHTML={{ __html: heading }}
        />
        {(paragraphs || []).map((text, index) => (
          <p key={index} className="text-neutral-500 leading-relaxed">
            {text}
          </p>
        ))}
        {faqLinkText && faqAnchor && (
          <div className="mt-2">
            <a
              className={`text-center block md:inline-block ${buttons.btnLargeExpressiveOutline}`}
              href={faqAnchor}
            >
              <span className="block">{faqLinkText}</span>
            </a>
          </div>
        )}
      </div>

      {/* Before / after pairs column */}
      <div className="col-span-4 mt-8 md:col-span-8 lg:mt-0 lg:col-span-6 lg:col-start-7 flex flex-col justify-center gap-y-8">
        {(pairs || []).map((pair, index) => (
          <figure key={index} className="m-0">
            <div className="grid grid-cols-2 gap-2">
              <PairImage src={pair.before} alt={pair.beforeAlt} label="Before" />
              <PairImage src={pair.after} alt={pair.afterAlt} label="After" />
            </div>
            {pair.caption && (
              <figcaption className="mt-3 text-sm text-neutral-500">
                {pair.caption}
              </figcaption>
            )}
          </figure>
        ))}
      </div>
    </div>
  </div>
)
